const SecondContainer = ({ children, className }) => {
  return (
    <div
      className={
        "max-w-[100rem] w-full mx-auto px-2 sm:p-6 bg-bkg rounded-md text-text-1  mt-[4rem] sm:mt-0 !pt-3  pb-10" +
        className
      }
    >
      {/* <div className="h-full w-full flex-1 overflow-auto bg-red-400"> */}
      {children}
      {/* </div> */}
      <div className="p-7 " />
    </div>
  );
};

export default SecondContainer;
